import React from 'react';
import { PreviewComponent } from './PreviewFruit';

const PreviewDelicatessen = props => (
    <div className="PreviewFruit">
        <div className={'CenterFruit o' + props.orientation}>
            <div className="PreviewFruitContainer">
                <PreviewComponent rayon="delicatessen" {...props} />
            </div>
        </div>
    </div>
);

export default PreviewDelicatessen;
